import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  operationCategoryAll: [],
  operationCategory: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const operationCategorySlice = createSlice({
  name: "operationCategory",
  initialState,
  reducers: {
    setOperationCategoryAll: (state, action) => {
      state.operationCategoryAll = action.payload;
    },
    setOperationCategory: (state, action) => {
      state.operationCategory = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setOperationCategoryAll,
  setOperationCategory,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = operationCategorySlice.actions;

export default operationCategorySlice.reducer;
